import { useEffect, useState } from 'react';
import apiService from '../../services/api';

/**
 * Création d’un Nr2jContact sur l’organisation (inline, sans quitter le contrat).
 */
export default function Nr2jCreateContactModal({
  open,
  organizationId,
  onClose,
  onSaved,
}) {
  const [prenom, setPrenom] = useState('');
  const [nom, setNom] = useState('');
  const [email, setEmail] = useState('');
  const [fonction, setFonction] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return;
    setPrenom('');
    setNom('');
    setEmail('');
    setFonction('');
    setError('');
  }, [open]);

  if (!open || !organizationId) return null;

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (!prenom.trim() && !nom.trim()) {
      setError('Indiquez au moins le prénom ou le nom.');
      return;
    }
    if (!email.trim() || !/@/.test(email)) {
      setError('Email valide requis.');
      return;
    }
    if (!fonction.trim()) {
      setError('Fonction requise pour un signataire.');
      return;
    }
    setBusy(true);
    try {
      const res = await apiService.createNr2jContact(organizationId, {
        prenom: prenom.trim(),
        nom: nom.trim(),
        email: email.trim(),
        fonction: fonction.trim(),
      });
      const created = res?.contact || res;
      onSaved?.(created);
      onClose?.();
    } catch (err) {
      setError(err?.message || 'Création impossible');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      data-testid="nr2j-create-contact-modal"
    >
      <form
        className="w-full max-w-md rounded-xl bg-white p-5 shadow-xl"
        onSubmit={handleSubmit}
      >
        <h3 className="text-lg font-semibold text-gray-900">Ajouter un contact</h3>
        <p className="mt-1 text-sm text-gray-600">
          Le contact est enregistré sur la fiche société et peut être choisi comme signataire.
        </p>
        <div className="mt-4 space-y-3">
          <div className="grid gap-3 sm:grid-cols-2">
            <label className="block text-sm">
              <span className="text-gray-500">Prénom</span>
              <input
                className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2"
                value={prenom}
                onChange={(ev) => setPrenom(ev.target.value)}
                data-testid="nr2j-create-contact-prenom"
              />
            </label>
            <label className="block text-sm">
              <span className="text-gray-500">Nom</span>
              <input
                className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2"
                value={nom}
                onChange={(ev) => setNom(ev.target.value)}
                data-testid="nr2j-create-contact-nom"
              />
            </label>
          </div>
          <label className="block text-sm">
            <span className="text-gray-500">Email</span>
            <input
              type="email"
              className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2"
              value={email}
              onChange={(ev) => setEmail(ev.target.value)}
              data-testid="nr2j-create-contact-email"
            />
          </label>
          <label className="block text-sm">
            <span className="text-gray-500">Fonction</span>
            <input
              className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2"
              value={fonction}
              onChange={(ev) => setFonction(ev.target.value)}
              data-testid="nr2j-create-contact-fonction"
            />
          </label>
        </div>
        {error ? (
          <p className="mt-3 text-sm text-rose-700" data-testid="nr2j-create-contact-error">{error}</p>
        ) : null}
        <div className="mt-5 flex gap-2">
          <button
            type="submit"
            disabled={busy}
            className="flex-1 rounded-lg bg-indigo-600 px-3 py-2 text-sm font-medium text-white disabled:opacity-50"
            data-testid="nr2j-create-contact-submit"
          >
            {busy ? 'Création…' : 'Créer le contact'}
          </button>
          <button
            type="button"
            disabled={busy}
            onClick={onClose}
            className="rounded-lg border px-3 py-2 text-sm"
          >
            Annuler
          </button>
        </div>
      </form>
    </div>
  );
}
